import { MachineDto, WebAppCommonModule } from '@allbesmart/web-app-common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'oaibox-machine-details',
    templateUrl: './machine-details.component.html',
    styleUrls: ['./machine-details.component.css'],
    imports: [WebAppCommonModule]
})
export class MachineDetailsComponent {

  @Input() machine?: MachineDto;

}
